import { Component, OnInit } from '@angular/core';
import { team } from './team-object';

@Component({
  selector: 'app-meet-the-team',
  templateUrl: './meet-the-team.component.html',
  styleUrls: ['./meet-the-team.component.scss']
})
export class MeetTheTeamComponent implements OnInit {
  meetTeam: any[] = team;
  breakpoints = {
    600: {
      perView: 1,
      startAt: 1,
      focusAt: 'center',
      gap: 20
    },
    1200: {
      perView: 3
    }
  };
  constructor() { }

  ngOnInit() {
  }

}
